import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCharger = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 10h6V5H6v5zm7 11H5a.967.967 0 0 1-.713-.288A.968.968 0 0 1 4 20V5c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 6 3h6c.55 0 1.02.196 1.412.587C13.804 3.98 14 4.45 14 5v7h1.25c.483 0 .896.17 1.238.512.341.342.512.755.512 1.238v4.625c0 .283.117.542.35.775.233.233.492.35.775.35.3 0 .563-.117.788-.35.224-.233.337-.492.337-.775V9H19a.968.968 0 0 1-.712-.287A.967.967 0 0 1 18 8V6.5c0-.133.05-.25.15-.35.1-.1.217-.15.35-.15V5c0-.133.05-.25.15-.35a.48.48 0 0 1 .7 0c.1.1.15.217.15.35v1h1V5c0-.133.05-.25.15-.35a.48.48 0 0 1 .7 0c.1.1.15.217.15.35v1c.133 0 .25.05.35.15.1.1.15.217.15.35V8c0 .283-.096.52-.288.713A.968.968 0 0 1 21 9h-.25v9.375c0 .7-.254 1.313-.762 1.837a2.493 2.493 0 0 1-1.863.788c-.717 0-1.333-.262-1.85-.788-.517-.524-.775-1.137-.775-1.837V13.75c0-.083-.02-.146-.063-.188-.041-.041-.104-.062-.187-.062H14V20c0 .283-.096.52-.287.712A.968.968 0 0 1 13 21zm-4.5-2 2.5-4H9.5v-3L7 16h1.5v3z",
		fill: "currentColor"
	})
});
export default SvgCharger;
